module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAN9JREFUKBWVUkEOgkAMbMHwAw7wBR5gQsKF+AxvqI8ycvMZhiMXznxhOfADErJ2dmmIBo1Osrvt7LS0dJkWWGuZhuEkbiUrW+hezpqS5MbMFhxjs+OY0DTdxSzhb6ChKDpyHA+By/xdjPgSCaFla8yZrL26rPNM1LZEPSoRZFJZnhOFofeZLzuxULMHxF2n3moXhXJVIJY2uGbWa5z6Nc9lCPgLCFgKFgs1v+OV69FDLWvvdGgQ0DK0ac9ir9n9VmMe4nyagcobStND4CYoQxG20ZuN0w9OpuAmDcGvT+MJ1bFNl0O2+roAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Result/imgs/report-icon-acne-2@2x.png
// module id = vICh
// module chunks = 1